<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"><em>For Our Mothers:</em></a></p><a id="page_v">
<p class="ded"><em>Ann LaFollette Helgesen</em><br/>&amp;<br/><em>Verna Ione Johnson</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?74455220